"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderModalHr = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const hrStyle = {
    margin: '0 0 0 0',
    padding: '0 0 0 0',
    border: 'none',
    borderTop: '1px solid #000',
    marginRight: 16,
    marginLeft: 16,
    marginTop: 8,
    marginBottom: 8,
};
const RenderModalHr = () => {
    return (0, jsx_runtime_1.jsx)("div", { style: hrStyle });
};
exports.RenderModalHr = RenderModalHr;
